import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1432.000000, -2207.000000)",
  fill: "#B9B9B9"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1432.000000, 2207.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.90909091,0 L29.0909091,0 C30.7054545,0 32,1.279375 32,2.875 L32,20.125 C32,21.720625 30.7054545,23 29.0909091,23 L2.90909091,23 C1.29454545,23 0,21.720625 0,20.125 L0.0145454545,2.875 C0.0145454545,1.279375 1.29454545,0 2.90909091,0 Z M2.90909091,20.125 L29.0909091,20.125 L29.0909091,12.9375 L29.0909091,11.5 L29.0909091,5.75 L29.0909091,2.875 L2.90909091,2.875 L2.90909091,5.75 L2.90909091,11.5 L2.90909091,12.9375 L2.90909091,20.125 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: "6",
  y: "3",
  width: "3",
  height: "17"
}), /*#__PURE__*/React.createElement("rect", {
  x: "12",
  y: "3",
  width: "3",
  height: "17"
}), /*#__PURE__*/React.createElement("rect", {
  x: "17",
  y: "3",
  width: "3",
  height: "17"
}), /*#__PURE__*/React.createElement("rect", {
  x: "23",
  y: "3",
  width: "3",
  height: "17"
}))), 'BankSlip', {
  viewBox: '0 0 32 23'
});